/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect, useRef, useCallback } from "react"
import OrgChart from "@balkangraph/orgchart.js"
// import OrgChart from "../balkan_orgchart/orgchart"
import { makeStyles } from "@mui/styles"
import {
    MenuItem,
    Select,
    Typography,
} from "@mui/material"
import { ReactComponent as PlusIcon } from "../icons/plus.svg"
import { ReactComponent as MinusIcon } from "../icons/minus.svg"
import ArrowDown from "../assets/icons/arrow-down.svg"
import ArrowUp from "../assets/icons/arrow-up.svg"
import ViewDetailIcon from "../assets/icons/document-chart.svg"
import avatarIcon from "../icons/avatar.svg"
import { useTranslation } from "react-i18next"
import * as Util from "../services/global.service"
import moment from "moment"

OrgChart.templates.goalChartTemplate = Object.assign({}, OrgChart.templates.ana)
OrgChart.templates.goalChartTemplate.size = [405, 361]
OrgChart.templates.goalChartTemplate.defs = '<linearGradient id="{randId}" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#fff;stop-opacity:1" />'
    + '<stop offset="100%" style="stop-color:#eee;stop-opacity:1" /></linearGradient>'
    + '<filter id="f3" x="0" y="0" width="200" height="200" > <feOffset result="offOut" in="SourceAlpha" dx="7" dy="7" /> <feColorMatrix result="matrixOut" in="offOut" type="matrix" values=" 0.49 0 0 0 0 0 0.49 0 0 0 0 0 0.49 0 0 0 0 0 0.5 0" /> <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="6" /> <feBlend in="SourceGraphic" in2="blurOut" mode="normal" /> </filter>';
OrgChart.templates.subLevel.link = '<path stroke-linejoin="round" stroke="#aeaeae" stroke-width="1px" fill="none" d="{rounded}" />'
OrgChart.templates.goalChartTemplate.plus = `<image href=${ArrowUp} width="15" height="15" alt="expand chart" x="7" y="-17"/>`
OrgChart.templates.goalChartTemplate.minus = `<image href=${ArrowDown} width="15" height="15" alt="expand chart" x="7" y="-17"/>`
OrgChart.templates.goalChartTemplate.node = '<rect fill="#fff" x="0" y="0" height="{h}" width="{w}" stroke-width="0" rx="7" ry="7" class="goal-chart-rect"></rect>'
OrgChart.templates.goalChartTemplate.obj = `<foreignObject x="0" y="0" width="405" height="1" class="fo-header" style="overflow: visible;">
        <div xmlns="http://www.w3.org/1999/xhtml">
            {val}
        </div>
    </foreignObject>`
OrgChart.templates.goalChartTemplate.ripple.color = "none"
OrgChart.miniMap.border = '2px solid #5DA196'
OrgChart.miniMap.focusStroke = "#5DA196"
OrgChart.miniMap.draggable = false

const useStyles = makeStyles({
})

var chart = null

const GoalAlignmentChart = (props) => {
    const divRef = useRef(null)
    const classes = useStyles()
    const [currentZoomSelected, setCurrentZoomSelected] = useState(100)
    const { i18n } = useTranslation()
    const [chartState, setChartState] = React.useState(0)
    const [isDomChartReady, setIsDomChartReady] = useState(false)


    const validateActualValueColor = (value, target = null, metric = null, condition = null) => {
        let result = false
        let targetCondition = ""
        if (condition && condition !== "") {
            targetCondition = condition.toLowerCase()
        }
        if (targetCondition !== "") {
            if (targetCondition === "equal") {
                if (parseFloat(target) === parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "higher or equal to") {
                if (parseFloat(target) <= parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "less or equal to") {
                if (parseFloat(target) >= parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "higher") {
                if (parseFloat(target) < parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "less") {
                if (parseFloat(target) > parseFloat(value)) {
                    result = true
                }
            }
        } else {
            console.log(metric?.toLowerCase())
            if (metric?.toLowerCase() === "accomplishment" || metric?.toLowerCase() === "ทำสำเร็จหรือไม่") {
                if (target?.toLowerCase() === value?.toLowerCase()) {
                    result = true
                }
            } else if (metric?.toLowerCase() === "date" || metric?.toLowerCase() === "ทำได้ภายใน end date") {
                console.log(target, value)
                let targetValue = moment(String(target), "DD-MM-YYYY")
                let actualValue = moment(String(value), "DD-MM-YYYY")
                let diff = targetValue.diff(actualValue, 'days')
                if (diff >= 0) {
                    result = true
                }
            } else {
                if (target >= value) {
                    result = true
                }
            }
        }
        return result
    }

    const findRoot = (data) => {
        let root = data?.[0]?.id ?? 0
        let roots = [...data].map(item => {
            if (item.pid === root) return item.id
        })
        return roots
    }

    const setZoomLevel = (val) => {
        setCurrentZoomSelected(val)
        const scaleInitial = chart.config.scaleInitial
        const currentScale = chart.getScale()
        const resetScale = scaleInitial / currentScale
        if (val === 100) {
            chart.zoom(resetScale / scaleInitial, [50, 50], true)
        } else {
            let valScale = val / 100
            chart.zoom(resetScale * valScale / scaleInitial, [50, 50], true)
        }
    }

    const doZoom = (val) => {
        const scaleInitial = chart.config.scaleInitial
        const currentScale = chart.getScale()
        const resetScale = scaleInitial / currentScale
        const zoomLevel = [25, 50, 75, 100, 150, 200, 300]
        const zoomLevelLength = zoomLevel.length
        let currentZoomLevel = zoomLevel.indexOf(currentZoomSelected)
        let valScale = 0
        if (val === "in") {
            if (currentZoomLevel > -1 && currentZoomLevel < zoomLevelLength - 1) {
                valScale = zoomLevel[currentZoomLevel + 1] / 100
                chart.zoom(resetScale * valScale / scaleInitial, [50, 50], true)
                setCurrentZoomSelected(zoomLevel[currentZoomLevel + 1])
            }
        } else {
            if (currentZoomLevel > 0) {
                valScale = zoomLevel[currentZoomLevel - 1] / 100
                chart.zoom(resetScale * valScale / scaleInitial, [50, 50], true)
                setCurrentZoomSelected(zoomLevel[currentZoomLevel - 1])
            }
        }
    }

    const doFitChart = () => {
        if (chart) {
            chart.fit()
            setCurrentZoomSelected("fit")
        }
    }

    const divRefCallback = useCallback((node) => {
        if (node) {
            divRef.current = node
            setIsDomChartReady(true)
        }
    }, [])

    useEffect(() => {
        if (props.nodes && props.nodes.length > 0 && isDomChartReady) {
            let data = props.nodes && props.nodes.length > 0 ? [...props.nodes] : []
            let roots = findRoot(data)
            console.log(data, roots)
            chart = new OrgChart(divRef.current, {
                template: "goalChartTemplate",
                miniMap: true,
                align: OrgChart.CENTER,
                nodes: data,
                orientation: OrgChart.orientation.top,
                showYScroll: true,
                showXScroll: true,
                mouseScrool: OrgChart.action.scroll,
                scaleInitial: OrgChart.match.boundary,
                scaleMax: 99999999999999,
                scaleMin: -99999999999999,
                enableSearch: false,
                collapse: { level: 2, allChildren: true },
                roots: [0],
                nodeBinding: {
                    obj: "obj"
                }
            })
            chart.on('field', function (sender, args) {
                if (args.data != null) {
                    var objData = args.data["obj"]
                    let tmpHtml = ""
                    tmpHtml = `<div style="border-radius: 7px; -webkit-box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.1); -moz-box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.1); box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.1); font-family: Kanit;">`
                    tmpHtml += `
                            <div class="goal-chart-head">
                                <div style="font-size: 16px; font-weight: 400; width: 90%;" class="tooltip"> 
                                    <div style="color: white;font-size: 16px; font-weight: 600; text-overflow: ellipsis; overflow: hidden; width: 100%; -webkit-line-clamp: 2;display: -webkit-box; -webkit-box-orient: vertical; line-break: anywhere;">${objData?.name ?? ""}</div>
                                    <div class="tooltiptext-bottom">${objData?.name}</div> 
                                </div>
                                <div style="font-size: 16px; font-weight: 400;" class="tooltip"> 
                                    <a style="display: flex; align-items: center; width: 40px; height: 40px; justify-content: center;" class="btn-svg" href="/kpi/mygoal-detail/${objData?.serial}" target="_blank" rel="noopener noreferrer">
                                        <img src="${ViewDetailIcon}" width="20" height="20" alt="view detail"/>
                                    </a>
                                    <div class="tooltiptext-left">${'View Detail'}</div> 
                                </div>
                            </div>
                            <div class="goal-chart-detail">
                                <div style="height: 40px; display: flex;">
                                    <div style="display: flex; width: 50px; margin-right: 5px;">
                                        <div class="goal-chart-profile-img">
                                            <img src="${objData?.employee?.photo && objData?.employee?.photo != "" ? objData.employee.photo : avatarIcon}" width="40" height="40"/>
                                        </div>
                                    </div>
                                    <div style="display: flex; flex-direction: column; margin-right: 5px; width: 100%;">
                                        <div style="height: 50%; display: flex; align-items: center; width: 100%;">
                                            <div style="font-size: 16px; font-weight: 400; width: 95%;" class="tooltip"> 
                                                <div style="text-overflow: ellipsis; white-space: nowrap; width: 100%; overflow: hidden; color: #404349;">${objData?.employee ? i18n.language === "th-TH" ? objData?.employee?.fullname_th : objData?.employee?.fullname_en : "Admin"} </div>
                                                <div class="tooltiptext">${objData?.employee ? i18n.language === "th-TH" ? objData?.employee?.fullname_th : objData?.employee?.fullname_en : "Admin"}</div> 
                                            </div>
                                        </div>
                                        <div style="height: 50%; display: flex; align-items: center; width: 100%;">
                                            <div style="font-size: 13px; font-weight: 400; color: #888F9D; width: 95%;" class="tooltip"> 
                                                <div style="text-overflow: ellipsis; white-space: nowrap; width: 100%; overflow: hidden;">${objData?.employee ? objData?.employee?.position : ""} ${objData?.employee ? "(" + objData?.employee?.organization + ")" : ""} </div>
                                                <div class="tooltiptext">${objData?.employee ? objData?.employee?.position : ""} ${objData?.employee ? "(" + objData?.employee?.organization + ")" : ""} </div> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="width: 100%; height: 1px; background-color: #E7E8E7; margin-top: 10px; margin-bottom: 10px;"></div>
                                <div style="display: flex; margin-bottom: 10px;">
                                    <div style="display: flex;">
                                        <div style="height: 50%; display: flex; align-items: center;">
                                            <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Progress: </p>
                                        </div>
                                    </div>
                                    <div style="display: flex; flex-direction: column; margin-left: auto;">
                                        <div style="width: 120px; padding-top: 8px; padding-bottom: 8px; height: 40px; text-align: center; border-radius: 5px; display: flex; align-items: center; justify-content: center; border: ${objData?.goal_progress?.goal_progress_data?.name === "Not Started" || objData?.goal_progress?.goal_progress_data?.name === "ยังไม่ได้ดำเนินการ" ? "1px solid #DADADA" : "0"}; background-color: ${objData?.goal_progress?.goal_progress_data?.color?.background ?? "#FFF"}; color: ${objData?.goal_progress?.goal_progress_data?.color?.font ?? "#DADADA"};">
                                            <p style="cursor: default; font-size: 13px;">${objData?.goal_progress?.goal_progress_data?.name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: flex; margin-bottom: 0px;">
                                        <div style="display: flex; align-items: center;">
                                            <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Actual Value: </p>
                                        </div>
                                    <div style="display: flex; flex-direction: column; margin-left: auto;">
                                        <p style="font-size: 16px; font-weight: 400; color:${objData?.progress_log?.length > 0 ? validateActualValueColor(objData?.progress_log?.[0]?.actual_value, objData?.goal_progress?.target_value, objData?.goal_progress?.goal_metric?.description, objData?.target_condition) ? "#5DA196" : "#CC6058" : "#828282"};"> ${objData?.progress_log?.[0]?.actual_value ?? ""} ${objData?.progress_log?.length > 0 && objData?.progress_log?.[0]?.actual_value !== "" ? objData?.goal_progress?.unit != "-" ? objData?.goal_progress?.unit : "" : "-"}</p>
                                    </div>
                                </div>
                                <div style="display: flex; margin-bottom: 10px;">
                                    <div style="display: flex; flex-direction: column; margin-left: auto;">
                                        <p style="font-size: 14px; font-weight: 400; color: #AAAAAA;"> (Result as of: ${objData?.progress_log?.[0]?.date ? Util.dateDayFormatAdmin(objData?.progress_log?.[0]?.date) : "-"}) </p>
                                    </div>
                                </div>
                                <div style="display: flex; margin-bottom: 10px;">
                                    <div style="display: flex; align-items: center;">
                                        <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Target Value: </p>
                                    </div>
                                    <div style="display: flex; flex-direction: column; margin-left: auto;">
                                        <p style="font-size: 16px; font-weight: 400; color: #404349;"> ${objData?.target_condition && objData?.target_condition != "" ? Util.capitalizedString(objData.target_condition) : ""} ${objData?.goal_progress?.target_value} ${objData?.goal_progress?.unit === "-" ? "" : objData?.goal_progress?.unit + "(s)"} </p>
                                    </div>
                                </div>
                                <div style="display: flex; margin-bottom: 10px;">
                                    <div style="display: flex; align-items: center;">
                                        <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Start Date-End Date: </p>
                                    </div>
                                    <div style="display: flex; flex-direction: column; margin-left: auto;">
                                        <p style="font-size: 16px; font-weight: 400; color: #404349;"> ${objData?.goal_progress?.start_date}-${objData?.goal_progress?.end_date} </p>
                                    </div>
                                </div>
                                <div style="margin-bottom: 20px;"></div>
                        `

                    // if (!objData.is_current_goal) {
                    //     tmpHtml += `
                    //         <div style="display: flex; justify-content: center; margin-top: 10px; margin-bottom: 10px;">
                    //             <a style="display: flex; align-items: center; width: 129px; height: 40px; border-radius: 5px; border: 1px solid #5DA196; justify-content: center;" class="btn-svg" href="/kpi/mygoal-detail/${objData?.serial}" target="_blank" rel="noopener noreferrer">
                    //                 <img src="${viewDetail}" width="20" height="20" />
                    //                 <p style="font-size: 16px; font-weight: 600; color: #5DA196; margin-left: 5px;"> View Detail </p>
                    //             </a>
                    //         </div>
                    //     `
                    // }

                    tmpHtml += `</div></div>`
                    args.value = tmpHtml
                }
            })

            chart.editUI.on('show', function (sender, nodeId) {
                return false
            })
            chart.changeRoots(roots)
        }
    }, [props.nodes, isDomChartReady])

    return (
        <React.Fragment>
            <div id="tree" ref={divRefCallback} style={{ height: 'calc(100vh - 250px)', width: '100%' }} ></div>
            <div style={{
                position: 'absolute',
                right: '30px',
                top: '120px',
                display: 'flex',
            }}>
                <div id="tree-zoom-minus" style={{ borderRadius: '4px 0px 0px 4px' }} class="zoomBtn" onClick={() => doZoom("out")}><MinusIcon></MinusIcon></div>
                <Select
                    id="metric-select"
                    variant="outlined"
                    defaultValue=""
                    displayEmpty
                    size="small"
                    fullWidth
                    className="white-bg"
                    sx={{ width: '100px', borderRadius: "0!important", borderLeft: 0, borderRight: 0 }}
                    value={currentZoomSelected}
                >
                    <MenuItem value={25} onClick={() => setZoomLevel(25)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>25%</Typography>
                    </MenuItem>
                    <MenuItem value={50} onClick={() => setZoomLevel(50)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>50%</Typography>
                    </MenuItem>
                    <MenuItem value={75} onClick={() => setZoomLevel(75)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>75%</Typography>
                    </MenuItem>
                    <MenuItem value={100} onClick={() => setZoomLevel(100)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>100%</Typography>
                    </MenuItem>
                    <MenuItem value={150} onClick={() => setZoomLevel(150)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>150%</Typography>
                    </MenuItem>
                    <MenuItem value={200} onClick={() => setZoomLevel(200)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>200%</Typography>
                    </MenuItem>
                    <MenuItem value={300} onClick={() => setZoomLevel(300)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>300%</Typography>
                    </MenuItem>
                    <MenuItem value={"fit"} onClick={() => doFitChart()}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>Fit</Typography>
                    </MenuItem>
                </Select>
                <div id="tree-zoom-plus" style={{ borderRadius: '0px 4px 4px 0px' }} class="zoomBtn" onClick={() => doZoom("in")}><PlusIcon></PlusIcon></div>
            </div>
        </React.Fragment>
    )
}

export default GoalAlignmentChart;
